import { firestore } from "../../../firebase";
import {
  collection,
  CollectionReference,
  DocumentData,
  onSnapshot,
  Query,
  QuerySnapshot,
  Unsubscribe,
} from "firebase/firestore";

export function getCollectionRef(
  path: string,
  converter?: any
): CollectionReference<DocumentData> {
  if (path) {
    const collectionRef = collection(firestore, path).withConverter(converter);
    if (collectionRef) return collectionRef;
  }

  throw new Error("Collection not found!");
}

export function onCollectionSnapshot<T>(
  query: Query<DocumentData>,
  onCreate: (data: T[]) => void,
  onChange: (data: T[]) => void,
  onRemove: (data: T[]) => void,
  onError: (error) => void
): Unsubscribe {
  return onSnapshot(
    query,
    (snapshot: QuerySnapshot<DocumentData>) => {
      if (snapshot.empty) {
        onCreate([]);
        return;
      }

      const added: T[] = [],
        changed: T[] = [],
        removed: T[] = [];

      snapshot.docChanges().forEach((docChange) => {
        const type = docChange.type;
        const data = docChange.doc.data() as T;

        if (type === "added") added.push(data);
        if (type === "modified") changed.push(data);
        if (type === "removed") removed.push(data);
      });

      if (added.length) onCreate(added);
      if (changed.length) onChange(changed);
      if (removed.length) onRemove(removed);
    },
    onError
  );
}
